import { ComponentPropsWithoutRef, FC } from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type BackButtonProps = {} & ComponentPropsWithoutRef<typeof Button>;

const BackButton: FC<BackButtonProps> = ({ variant, color, startIcon, children, onClick, ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (e: any) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant={variant ?? 'outlined'}
      color={color ?? 'primary'}
      startIcon={startIcon ?? <NavigateBeforeIcon />}
      {...rest}
    >
      {children ?? t('button.goBack')}
    </Button>
  );
};

export default BackButton;
